
const columnList: Array<any> = [
    {
        prop: "name",
        label: "登录账号",
        width: 150,
    },
    {
        prop: "nickname",
        label: "姓名",
        width: 100,
    },
    {
        prop: "phone",
        label: "手机号码",
        width: 150,
    },
    {
        prop: "entry_time_text",
        label: "入职时间",
        width: 150,
    },
    {
        prop: "branch_name",
        label: "所属部门",
        width: 100,
    },
    {
        prop: "admin_role",
        label: "角色权限",
        width: 100,
    },
];
import {Request} from "@/api/request";

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {getPurchaseTable, getSupplierList, permissionList} from "@/api/http";
import {column} from "@/assets/types/common";
import {storeUser} from "@/store/User";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    name: "personnelStaff",
    setup() {
        const setTitle: any = inject("setTitle");
        let user = storeUser.getUser();
        setTitle(["员工管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            store_id = ref(0),
            total = ref(0),
            roleList = ref({} as any),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter = ref({
                page: currentPage.value,
                limit: pageSize.value,
                search: "",
                status: null,
                store_id: store_id.value,
                branch_id: "",
            }),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as any),
            dialog_show = ref(false),
            form_isload = ref(false),
            form = ref({
                name: "",
                phone: "",
                nickname: "",
                position_id: "",
                branch_id: "",
                role_id: "",
                gender: "",
                qq: "",
                wechat: "",
                email: "",
                identity_number: "",
                address: "",
                entry_time: "",
                entry_time_text:""
            } as any),
            formRef = ref(null),
            formRules = {
                name: [{required: true, message: "必填", trigger: "blur"}],
                role_id: [
                    {required: true, message: "必填", trigger: "changle"},
                ],
                gender: [
                    {required: true, message: "必填", trigger: "changle"},
                ],
                nickname: [
                    {required: true, message: "必填", trigger: "blur"},
                ],
                phone: [
                    {required: true, message: "必填", trigger: "changle"},
                ],
                position_id: [
                    {required: true, message: "必填", trigger: "changle"},
                ],
                branch_id: [
                    {required: true, message: "必填", trigger: "changle"},
                ],
            },
            form_positionList = ref([]),
            form_branchList = ref([]),
            form_roleList = ref([]),
            isEdit = ref(false),
            editId: any = null,
            _uprowStatus = (id: number, status: number): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Admin/upStateAdminStaff",
                    data: {
						id: id, 
						store_id: store_id.value,
						status: status == 0 ? 1 : 0,
					},
                }).then((res: any) => {
                    getTableData();
                });
            },
            _resetPassword = (id: number) => {
                if (!confirm("是否将该用户重置密码为门店统一初始密码？(可在门店设置中修改初始密码)")) return;
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Admin/resetPassword",
                    data: {
						id,
						store_id: store_id.value,
					},
                }).then((res: any) => {
                    loading.value = false;
                });
            },
            edit = (id: number) => {
                editId = id
                isEdit.value = true
                dialog_show.value = true;
                form_isload.value = true;
                Request.axiosInstance({
                    url: "adminapi/Admin/editInfoAdminStaff",
                    data: {
                        id,
						store_id: store_id.value,
                    },
                }).then((res: any) => {
                    form_isload.value = false;
                    if (res.status == 200) {
                        Object.keys(form.value).forEach((key) => {
                            form.value[key] = res.content[key];
                        });
                    }
                    console.log(form.value)
                });
            },
            entryTimeChange = (e:any)=> {
                let entry_time = Math.floor(e.getTime()/1000);
                form.value.entry_time = entry_time;
            },
            submitForm = () => {
                //let entry_time = Math.floor(form.value.entry_time.getTime()/1000);
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let data = {
							store_id: store_id.value,
                            ...form.value
                        }
                        let url = 'adminapi/Admin/createAdminStaff'
                        if (isEdit.value) {
                            url = 'adminapi/Admin/editAdminStaff'
                            data = {
                                id: editId,
                                store_id: store_id.value,
                                ...data
                            }
                        }
                        Request.axiosInstance({
                            url,
                            data
                        }).then((res: any) => {
							dialog_show.value = false;
							if(res.status == 202){
								getTableData()
							}
                        });
                    }
                })
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
				screenParameter.value.limit = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
				screenParameter.value.page = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'personnel_staff',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
				screenParameter.value.store_id = store_id.value;
                Request.axiosInstance({
                    url: "adminapi/Admin/listAdminStaff",
                    data: screenParameter.value,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            selectChange = (e: number): void => {
                getTableData();
            };
        
        onMounted(() => {
			if(useRoute().query.store_id){
				store_id.value = Number(useRoute().query.store_id);
			}
            Request.axiosInstance({
                url: "adminapi/Branch/list",
                data: {status: 1},
            }).then((res: any) => {
                form_branchList.value = res?.content?.list || [];
                getTableData();
            });
            Request.axiosInstance({
                url: "adminapi/Position/list",
                data: {status: 1},
            }).then((res: any) => {
                form_positionList.value = res?.content?.list || [];
                Request.axiosInstance({
                    url: "adminapi/Role/list",
                    data: {store_id: store_id.value},
                }).then((res: any) => {
                    form_roleList.value = res?.content?.list || [];
                });
            });
        });
        watch(dialog_show, (newValue) => {
            if (!newValue) {
                isEdit.value = false
            }
        })
        
        return {
            columnList,
            tableData,
            loading,
            headClass,
            screen,
            screenParameter,
            selectChange,
            dialog_show,
            total,
            pageSize,
            currentPage,
            handleSizeChange,
            handleCurrentChange,
            form,
            formRef,
            formRules,
            form_isload,
            form_positionList,
            form_branchList,
            form_roleList,
            _uprowStatus,
            _resetPassword,
            isEdit,
            edit,
            submitForm,
            entryTimeChange,
            roleList
        };
    },
});
